// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles';

class MapPreview extends React.Component {
  state = {};

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.mainContainer} />
    );
  }
}

MapPreview.propTypes = {
  classes: PropTypes.object,
};

MapPreview.defaultProps = {
  classes: {},
};

export default withStyles(styles)(MapPreview);
